import React, { useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import '../../navigationBar.scss'

const Link = ({ link, path, SetTrigger = () => {} }) => {
  const history = useHistory()

  const { pathname } = useLocation()
  const [isActive, setIsActive] = useState()

  const activeLink = (path) => {
    pathname.includes(path.toLowerCase()) && setIsActive(true)
  }
  return (
    <div>
      <li
        className={isActive ? 'active' : null}
        onClick={() => {
          activeLink(path)
          history.push(`/${path}`)
          SetTrigger()
        }}
      >
        {link}
      </li>
    </div>
  )
}

export default Link
